import { Inject, Injectable } from '@angular/core';
import { API_URL } from '../../app-store-providers';
import { HttpClient } from '@angular/common/http';
import { EntityTypes } from '../../entity/entity-types';
import { StoreBaseService } from '../../common/base.service';
import { ArticleVideoContentPayload } from './models/video-content-payload';
import { ArticleVideoContent } from './models/video-content';

@Injectable({
  providedIn: 'root'
})
export class ArticleVideoContentService
  extends StoreBaseService<ArticleVideoContent, ArticleVideoContentPayload> {

  get entityType(): string {
    return EntityTypes.articleVideoContent;
  }

  get resourceName(): string {
    return 'video-content';
  }

  constructor(
    @Inject(API_URL) apiUrl: string,
    http: HttpClient
  ) {
    super(apiUrl, http);
  }
}
